import { Typography } from '@capsule/consumer-design-system';

import styled from 'styled-components';

export const DoctorItem = styled.li`
  margin-bottom: ${props => props.theme.space.s3};
  display: flex;
  align-items: center;
`;

export const DoctorLabel = styled(Typography).attrs({ as: 'span', variant: 'body' })`
  margin-left: ${props => props.theme.space.s2};
`;
